import { render, staticRenderFns } from "./RegistrationCompletionFormSba.vue?vue&type=template&id=e8fe8dfe&scoped=true&"
import script from "./RegistrationCompletionFormSba.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompletionFormSba.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCompletionFormSba.vue?vue&type=style&index=0&id=e8fe8dfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8fe8dfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDatePicker,VForm,VMenu,VProgressCircular,VRow,VTextField})
